import React from 'react';
import { ShieldCheck, Feather, Sparkles, Smile } from 'lucide-react';
import { features, lifestyleImages } from '../mock';

const iconMap = {
  'shield-check': ShieldCheck,
  feather: Feather,
  sparkles: Sparkles,
  smile: Smile
};

export const Features = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-900 to-blue-800 text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-yellow-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black mb-6">
            Diseñadas para cuidarte
            <span className="block mt-2 text-yellow-400">mientras disfrutas</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {features.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 border border-white/20"
              >
                <div className="bg-yellow-400 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-12 transition-all">
                  <Icon className="text-blue-900" size={32} strokeWidth={2.5} />
                </div>
                <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                <p className="text-blue-100 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Additional Features Grid */}
        <div className="mt-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold mb-6">Tecnología que marca la diferencia</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-yellow-400 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-blue-900" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">No se resbalan</h4>
                  <p className="text-blue-100">Diseño ergonómico que se mantiene en su lugar durante cualquier actividad</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-yellow-400 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-blue-900" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Lentes polarizadas</h4>
                  <p className="text-blue-100">Reducen el deslumbramiento y mejoran la claridad visual</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-yellow-400 p-2 rounded-lg flex-shrink-0">
                  <svg className="w-6 h-6 text-blue-900" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Resistentes al sudor</h4>
                  <p className="text-blue-100">Materiales que resisten la humedad y son fáciles de limpiar</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src={lifestyleImages.stadium} 
              alt="Hincha de La Tri usando gafas en el estadio"
              className="rounded-3xl shadow-2xl w-full object-cover aspect-[4/5]"
             loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
